import { render, staticRenderFns } from "./BookStoreOverview.vue?vue&type=template&id=3484b3aa"
import script from "./BookStoreOverview.vue?vue&type=script&lang=js"
export * from "./BookStoreOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports